import React, { useContext } from "react";
import GameTimer from "../Components/GameTimer";
import QuitGameButton from "../Components/QuitGameButton";
import { MemoryLevelContext } from "../Context/MemoryLevelContext";

const MemoryGameHeading = () => {
    const {displayTimer} = useContext(MemoryLevelContext);
    return(
        <div className="memory-timer-container">
            <QuitGameButton />
            {displayTimer &&
                <GameTimer/>
            }
        </div>
    );
};

export default MemoryGameHeading;